import Axios from 'axios';

// Get CSRFToken for header in API call to db
Axios.defaults.xsrfCookieName = 'csrftoken';
Axios.defaults.xsrfHeaderName = 'X-CSRFToken';

export default class ArticleValidationService {
  baseUrl = '/api/v3/selfservice/article-licensing/resolve-newspost-url/';

  async resolveNewspostUrl(newspostUrl) {
    const url = `${this.baseUrl}?newspost_url=${newspostUrl}`;
    try {
      const response = await Axios.get(url);
      return response.data.newspost;
    } catch (error) {
      throw new Error('Invalid article link');
    }
  }
}
